import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Box,
  Card,
  Flex,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";
import { FiSearch, FiTrash, FiDownload } from "react-icons/fi";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import CustomToolTip from "../../components/CustomTooltip";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import {
  get_all_inventory_list,
  get_inventory_list,
} from "../../redux/inventorySlice";
import CustomSingleInput from "../../components/CustomSingleInput";
import { baseUrl } from "../../utils/utils";
import Loader from "../../components/Loader";
import { get_all_customer_list } from "../../redux/customerSlice";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const LedgerReports = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPartyDropdown, setShowPartyDropdown] = useState(false);
  const navigate = useNavigate();
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [total_count, setTotal_count] = useState(0);
  const [reports_list, setReports_list] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openingEmptys, setOpeningEmptys] = useState("");
  const [openingFulls, setOpeningFulls] = useState("");
  const { all_inventory_list } = useSelector((state) => state.inventory);
  const { all_customer_list, all_loading } = useSelector((state) => state.customers);
const [hasSearched, setHasSearched] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [data, setData] = useState({});
  const [reportType, setReportType] = useState("");
  const [partyList, setPartyList] = useState([]);
  const [selectedParty, setSelectedParty] = useState(null);
  const [partySearchTerm, setPartySearchTerm] = useState("");
  const [filteredPartyList, setFilteredPartyList] = useState([]);
  const [partyLoading, setPartyLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [reportFileUrl, setReportFileUrl] = useState(null);

  const product_list = all_inventory_list?.map((v) => ({
    label: `${v?.product_name} - ${v?.type}`,
    value: v?.uuid,
  }));

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `inventory.php`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const result = await response.json();
      if (result?.success) {
        store.dispatch(get_inventory_list({ page: page, rows: rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      toast.error("Failed to load product data", {
        position: "top-right",
        autoClose: 5000,
      });
      navigate("/products");
    } finally {
      setIsLoading(false);
    }
  };

  const get_report_list = async () => {
    try {
      setLoading(true);
      const body = new FormData();

      if (reportType === "ProductWise") {
        body.append("action", "fetchledgerreport");
        body.append("prod_code", selectedProduct);
      } else {
        body.append("action", "partywiseledger");
        body.append("userid", selectedParty);
      }

      body.append("page", page);
      body.append("limit", rows);
      body.append("fd", startDate);
      body.append("td", endDate);

      const response = await fetch(`${baseUrl}reports/ledger_report.php`, {
        method: "POST",
        body,
      });

      const res = await response.json();
      if (res?.success) {
        setReports_list(res?.list);
        setTotal_count(res.totalcount);
        setOpeningFulls(res.openingFulls);
        setOpeningEmptys(res.openingEmptys);
        setReportFileUrl(res?.report_url);
      } else {
        setReports_list([]);
        setTotal_count(0);
        setReportFileUrl(null);
      }
    } catch (error) {
      console.log("Failed to fetch inventory list.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    store.dispatch(get_all_inventory_list());
  }, []);

useEffect(() => {
  if (reportType === "PartyWise") {
    store.dispatch(get_all_customer_list({ page: 1, rows: 10000 }));
  }
}, [reportType]);
  

useEffect(() => {
  if (reportType === "PartyWise") {
    const customerList = all_customer_list.map((item) => ({
      id: item.id,
      name: item.name || item.mobile,
      mobile: item.mobile,
      email: item.email,
    }));
    setPartyList(customerList);
    setFilteredPartyList(customerList);
  }
}, [all_customer_list, reportType]);

// This will only trigger when page/rows change AFTER initial search
useEffect(() => {
  if (Object.keys(data).length > 0) {
    get_report_list();
  }
}, [page, rows]);

  const handleRowsChange = (e) => {
    const newRows = Number(e.target.value);
    setRows(newRows);
    setPage(1);
    setInitialValue(1);
  };

  const handlePrevious = () => {
    if (page > 1) {
      setPage(page - 1);
      setInitialValue(initialValue - rows);
    }
  };

  const handleNext = () => {
    if (rows * page < total_count) {
      setPage(page + 1);
      setInitialValue(initialValue + rows);
    }
  };

const handleSearch = () => {
  if (!startDate || !endDate) {
    toast.error("Please select both start and end dates");
    return;
  }

  if (reportType === "ProductWise" && !selectedProduct) {
    toast.error("Please select a product");
    return;
  }

  if (reportType === "PartyWise" && !selectedParty) {
    toast.error("Please select a party");
    return;
  }

  setPage(1);
  setInitialValue(1);

  if (reportType === "ProductWise") {
    setData({
      sd: startDate,
      ed: endDate,
      pcode: selectedProduct,
    });
  } else {
    setData({
      sd: startDate,
      ed: endDate,
      userid: selectedParty,
    });
  }

  // mark that the user performed a manual search
  setHasSearched(true);

  get_report_list();
};


  const handleReportTypeChange = (e) => {
    const value = e.target.value;
    setReportType(value);
    setSelectedProduct(null);
    setSelectedParty(null);
    setPartySearchTerm("");
    setReports_list([]);
    setTotal_count(0);
    setPage(1);
    setInitialValue(1);
    setReportFileUrl(null);
  };

  const handleDownloadExcel = () => {
    if (!reportFileUrl) {
      toast.error("No file available for download");
      return;
    }
  
    try {
      const link = document.createElement("a");
      link.href = reportFileUrl;
      link.setAttribute(
        "download",
        reportFileUrl.split("/").pop() || "ledger_report.xlsx"
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      toast.success("File download initiated");
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download file");
    }
  };
  
  // FILTER PARTY LIST BASED ON SEARCH
useEffect(() => {
  if (!partySearchTerm) {
    setFilteredPartyList(partyList);
    return;
  }

  const term = partySearchTerm.toLowerCase();

  const filtered = partyList.filter((p) =>
    p.name?.toLowerCase().includes(term) ||
    p.mobile?.toLowerCase().includes(term)
  );

  setFilteredPartyList(filtered);
}, [partySearchTerm, partyList]);

// Auto-search if product/party changes AFTER initial manual search
useEffect(() => {
  if (!hasSearched) return; // only run after first manual search
  if (!reportType || !startDate || !endDate) return;

  // Product auto-search
  if (reportType === "ProductWise" && selectedProduct) {
    setPage(1);
    setInitialValue(1);

    get_report_list();
  }

  // Party auto-search
  if (reportType === "PartyWise" && selectedParty) {
    setPage(1);
    setInitialValue(1);

    get_report_list();
  }

}, [selectedProduct, selectedParty]);


  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        flexDirection={["column", "row"]}
        alignItems={["flex-end", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading
          display="flex"
          w="full"
          alignItems="center"
          justifyContent="space-between"
          fontSize="xl"
        >
          Ledger Reports
          {reportFileUrl && (
            <CustomButton
              title="Download Excel"
              leftIcon={<FiDownload />}
              onClick={handleDownloadExcel}
              isLoading={downloadLoading}
            />
          )}
        </Heading>
        <Spacer display={["none", "block"]} />
      </Card>

      <Card bg="#fff" py={3} px={5} gap={3}>
        <Flex
          direction={["column", "row"]}
          gap={3}
          flexWrap="wrap"
          w="full"
          justify="flex-start"
          alignItems={"flex-end"}
        >
          <CustomSingleInput
            width={["100%", "200px"]}
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <CustomSingleInput
            width={["100%", "200px"]}
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <CustomSingleInput
            label="Report Type"
            width={["100%", "200px"]}
            placeholder="Select Report Type"
            select
            options={[
              { label: "ProductWise", value: "ProductWise" },
              { label: "PartyWise", value: "PartyWise" },
            ]}
            value={reportType}
            onChange={handleReportTypeChange}
          />

          {reportType === "ProductWise" && (
            <CustomSingleInput
              label="Product"
              width={["100%", "200px"]}
              placeholder="Select Product"
              select
              options={product_list}
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e.target.value)}
            />
          )}

{reportType === "PartyWise" && (
  <Box width={["100%", "200px"]} position="relative">
    <CustomSingleInput
      label="Party"
      width="100%"
      placeholder="Select Party"
      type="text"
      value={
        selectedParty
          ? filteredPartyList.find((p) => p.id === selectedParty)?.name || ""
          : partySearchTerm
      }
      onChange={(e) => {
        setPartySearchTerm(e.target.value);
        setSelectedParty(null);
        setShowPartyDropdown(true);
      }}
      onFocus={() => setShowPartyDropdown(true)}
    />
    
    {showPartyDropdown && filteredPartyList.length > 0 && (
      <Box
        position="absolute"
        top="100%"
        left={0}
        right={0}
        mt={1}
        maxH="240px"
        overflowY="auto"
        zIndex={1000}
        bg="white"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        boxShadow="md"
      >
        {filteredPartyList.map((party) => (
          <Flex
            key={party.id}
            direction="column"
            p={3}
            cursor="pointer"
            bg={selectedParty === party.id ? "blue.50" : "white"}
            borderBottom="1px solid"
            borderColor="gray.100"
            _hover={{ bg: "gray.50" }}
            _last={{ borderBottom: "none" }}
            onClick={() => {
              setSelectedParty(party.id);
              setShowPartyDropdown(false);
              setPartySearchTerm("");
            }}
          >
            <Text fontSize="sm" fontWeight="600" color="gray.800">
              {party.name}
            </Text>
          </Flex>
        ))}
      </Box>
    )}
  </Box>
)}

          {reportType && (
            <CustomButton
              title="Search"
              w={["100%", "auto"]}
              height={"40px"}
              onClick={handleSearch}
            />
          )}
        </Flex>
      </Card>

      {loading ? (
        <>
        <GasCylinderLoader/>
        </>
      ) : reports_list?.length === 0 ? (
        <Card justifyContent="center" alignItems="center" h={20}>
          <Text>No Data</Text>
        </Card>
      ) : (
        <Card>
          <TableView
            headData={
              reportType === "ProductWise"
                ? [
                    "S.No.",
                    "INV No",
                    "INV DATE",
                    "TRANSACTION TYPE",
                    "Quantity",
                    "Empties",
                    "Current Fulls",
                    "Current Empties",
                  ]
                : [
                  "Invoice No.",
                  "Order Id",
                  "Ordered Date",
                  "Invoice Amount",
                  "Debit",
                  "Credit",
                  "Closing Balance",
                 
                  "Delivered Date",
                  
                  ]
            }
            body={
              reportType === "ProductWise"
                ? reports_list?.map((el, i) => (
                    <Tr key={i}>
                      <Td textAlign="center">{i + initialValue}</Td>
                      <Td textAlign="center">{el.inv_no}</Td>
                      <Td textAlign="center">{el.trans_date}</Td>
                      <Td textAlign="center">{el.TRANSACTION_TYPE}</Td>
                      <Td textAlign="center">{el.fulls}</Td>
                      <Td textAlign="center">{el.emptys}</Td>
                      <Td textAlign="center">{el.CS_FULLS}</Td>
                      <Td textAlign="center">{el.CS_EMPTYS}</Td>
                    </Tr>
                  ))
                : reports_list?.map((el, i) => (
                    <Tr key={i}>
                       <Td textAlign="center">{el.sr_no ? el.sr_no :"NA"}</Td>
                      <Td textAlign="center">{el.orderid ? el.orderid :"NA"}</Td>
                      <Td textAlign="center">{el.orderdate ? el.orderdate :"NA"}</Td>
                      <Td textAlign="center">{el.amount ? el.amount :"NA"}</Td>
                      <Td textAlign="center">{el.debit ? el.debit :"NA"}</Td>
                      <Td textAlign="center">{el.credit ? el.credit :"NA"}</Td>
                      <Td textAlign="center">{el.balance ? el.balance :"NA"}</Td>
                      <Td textAlign="center">{el.delivery_datetime ? el.delivery_datetime :"NA"}</Td>
                    </Tr>
                  ))
            }
            initialValue={initialValue}
            page={page}
            rows={rows}
            total_value={total_count}
            pagination
            onChange={handleRowsChange}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />
          <ConfirmDialog  
            isOpen={deleteDialog}
            onClose={() => setDeleteDialog(false)}
            onConfirm={handleDelete}
            type="delete"
            title="Delete Inventory"
            message="Are you sure you want to delete this Inventory? This action cannot be undone and will remove all associated data."
            confirmText="Delete"
            cancelText="Cancel"
            isLoading={isLoading}
          />
        </Card>
      )}
    </>
  );
};

export default LedgerReports;